import { render, staticRenderFns } from "./CouponAdd.vue?vue&type=template&id=925d511c&scoped=true&"
import script from "./CouponAdd.vue?vue&type=script&lang=js&"
export * from "./CouponAdd.vue?vue&type=script&lang=js&"
import style0 from "./CouponAdd.vue?vue&type=style&index=0&id=925d511c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925d511c",
  null
  
)

export default component.exports